import axios from "axios";

const ID_TOKEN_KEY = "myIllini-student-auth";
const OTHER_KEY = ".AspNetCore.myIlliniStudentAuth";
const SESSION_KEY = ".AspNetCore.Session.myIlliniStudent";

export const getToken = () => {
    return window.$cookies.get(ID_TOKEN_KEY);
};

export const destroyToken = () => {
    window.$cookies.remove(ID_TOKEN_KEY);
    window.$cookies.remove(OTHER_KEY);
    window.$cookies.remove(SESSION_KEY);
};

export const createToken = (token) => {
    window.$cookies.set(ID_TOKEN_KEY, token, "2d", "/", window.location.hostname);
}

export const setAuthHeader = () => {
    axios.defaults.headers.common["Authorization"] = `Bearer ${getToken()}`;
}
export default { getToken, destroyToken, setAuthHeader, createToken };